import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { RoadOccupationForm, RoadOccupationFormValue } from '../../forms/road-occupation.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StageFormComponent } from '../stage-form/stage-form.component';
import { Store } from '@ngrx/store';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { TabViewComponent } from '../../../../../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../../../../../common/tab-view/tab-panel.component';
import { RoadOccupationTypeAppEntityDictionaryRoadOccupationType } from '../../../../../../../openapi';
import { selectRoadOccupationTypes } from '../../../../../../../store/selectors/application.selectors';
import { DpDatePickerModule } from 'ng2-date-picker';
import { DatePickerComponent } from '../../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    TabViewComponent,
    TabPanelComponent,
    StageFormComponent,
    DpDatePickerModule,
    NgxMaskDirective,
    DatePickerComponent
  ],
  templateUrl: './road-occupation-form.component.html'
})
export class RoadOccupationFormComponent {

  @Input()
  public workPurposeControlType: 'select' | 'textarea' = 'select';

  @Input()
  public edit: boolean = false;

  @Input()
  public showCancel: boolean = true;

  @Input()
  public form: RoadOccupationForm | undefined;

  @Output()
  public onSubmit = new EventEmitter<RoadOccupationFormValue>();

  @Output()
  public onCancel = new EventEmitter();

  public roadOccupationTypes: Signal<RoadOccupationTypeAppEntityDictionaryRoadOccupationType[]> = this.store$.selectSignal(selectRoadOccupationTypes);

  constructor(private store$: Store) {
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.values);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset();
  }

}
